module.exports = __webpack_public_path__ + "static/media/logoweb2.3f8faa40.png";